/**
 * Export Jurisdiction and Classification U.S. EAR99, India Not Subject to Regulations
 */

import { AttributeInputCallback, type Callback, CallbackType } from "@forgerock/javascript-sdk";
import type { JSX } from "react";
import CustomTextField from "../components/common/CustomFormElements/CustomTextField/CustomTextField";
import { isNil } from "lodash";
import CustomPasswordElement from "../components/common/CustomFormElements/CustomPasswordElement/CustomPasswordElement";
import CustomSelectField from "../components/common/CustomFormElements/CustomSelectField/CustomSelectField";
import { isJsonString } from "./FRCallBackUtil";
import "./uiHelper.css"
import { useTranslation } from "../components/common/Translation/translationProvider";
import { Button } from "@mui/material";



export const getNameValueJsonArray = (data: any) => {
    let jsonArrayObject: any[] = [];
    if (!!data) {
        if ((typeof data === 'string')) {
            if (data.indexOf('[') === -1) {
                jsonArrayObject.push({ 'name': data, 'value': data })
            } else {
                /**it is string of array */
                if (isJsonString(data)) {
                    const parsedJson = JSON.parse(data);
                    if (parsedJson.length) {
                        parsedJson.forEach((element: any) => {
                            if (element['_id'] && element['country'] && element['name']) {
                                jsonArrayObject.push({ 'name': element['name'] + "(" + element['country'] + ")", 'value': element['_id'] });
                            } else {
                                if(!!element['displayName']){
                                    jsonArrayObject.push({ 'name': element['displayName'], 'value': element['value'] });
                                } else {
                                    jsonArrayObject.push({ 'name': element['name'], 'value': element['value'] })
                                }
                            }
                        });
                    }
                } else {
                    data.slice(1, -1).split(',').forEach((value: any) => {
                        jsonArrayObject.push({ 'name': value, 'value': value });
                    })
                }

            }
        } else {
                data.forEach((value: any) => {
                    if (!!value){
                        if (value['_id'] && value['country'] && value['name']) {
                            jsonArrayObject.push({ 'name': value['name'] + "(" + value['country'] + ")", 'value': value['_id'] });
                        } else if (value['_id'] && value['registrationCode'] && value['name']) {
                            jsonArrayObject.push({ 'name': value['name'] + " ( " + value['registrationCode'] + " )", 'value': value['_id'] });
                        } else if (value['name'] && value['value']) {
                            jsonArrayObject.push({ 'name': value['name'], 'value': value['value'] });
                        } else if (typeof value === 'string') {
                            jsonArrayObject.push({ 'name': value, 'value': value });
                        } else if (value['_id'] && value['name']) {
                            jsonArrayObject.push({ 'name': value['name'] , 'value': value['_id'] });
                        } else {
                            console.error("data format for select options is wrong")
                        }
                    }
                })
        }
    }
    return jsonArrayObject;
}

 const getOptionsFromPolicy = (attributeInputCallback: AttributeInputCallback<string | number | boolean>,customCountryTopElement:string,uiType?: string) => {
    const options = getPolicyByPolicyID(attributeInputCallback, 'OPTIONS', 'values')
    if (!isNil(options)) {
        if (uiType === 'select') {
            return getNameValueJsonArray(options)
        } else {
            return options;
        }
    }
   

}

export const getPolicyByPolicyID = (attributeInputCallback: AttributeInputCallback<string | number | boolean>, policyId: string, valueKey?: string) => {
    if (!!attributeInputCallback.getPolicies()['policyRequirements']) {
        const policyIndex = attributeInputCallback.getPolicies()['policyRequirements'].indexOf(policyId)
        if (!!valueKey) {
            if (policyIndex > -1) {
                const options = attributeInputCallback.getPolicies()['policies'][policyIndex]['params'][valueKey];
                return options
            }
        } else {
            if (!isNil(attributeInputCallback.getPolicies()['policies'][policyIndex])) {
                return attributeInputCallback.getPolicies()['policies'][policyIndex]['params']
            }

        }
    }
    return undefined;
}


const validatedCreatePasswordCallback = (attributeInputCallback: AttributeInputCallback<string | number | boolean>, value: any, t: (key:string) => string) => {
    let result: number = 0;
    const policies = getPolicyByPolicyID(attributeInputCallback, 'STRONG_PASSWORD_VALIDATION');
    let patterns: any[] = [];
    if (!isNil(policies)) {
        Object.keys(policies).forEach((item) => {
            if (item !== "reqStrenght") {
                patterns.push(policies[item]);
            }
        });
        patterns.forEach(pattern => {
            if (value.match(pattern)) {
                result++;
            }
        })

        if (result < policies['reqStrenght']) {
            return getUItypeValidationMessage(attributeInputCallback,t, 'strongPasswordMessage');
        }
    }
    return undefined;
}

const getUItypeValidationMessage = (attributeInputCallback: AttributeInputCallback<string | number | boolean>,t : (key:string,param?:Record<string,any>) => string ,validationMessageName?: string  ) => {
  
    if (!!attributeInputCallback.getPolicies()['policyRequirements']) {
        const uiTypeIndex = attributeInputCallback.getPolicies()['policyRequirements'].indexOf("UI-TYPE")
        if (uiTypeIndex > -1) {
            const validationMessage = attributeInputCallback.getPolicies()['policies'][uiTypeIndex]['params'][!!validationMessageName ? validationMessageName : 'validationMessage'];
            if (!!validationMessage) {
                return t(validationMessage);
            } else if (validationMessageName === 'minLength' || validationMessageName === 'maxLength') {
                return undefined;
            } 
            else if(validationMessageName === 'maxLengthMessage'){
                return undefined;
            }
            else {
                return t('common.validValue');
            }
        }
    }

}


const getValidationMessage = (attributeInputCallback: AttributeInputCallback<string | number | boolean>, value: any,t : (key:string,param?:Record<string,any>) => string , validationValues?: { value: any[], message: string }, validSecondaryEmail?: { value: string, message: string }) => {
    const policies = attributeInputCallback.getPolicies()['policies'];
    
    let validation;
    if (!!value) {
        policies?.forEach((policy: any) => {
            switch (policy['policyRequirements'][0]) {
                case 'MATCH_REGEXP':
                    const matches = new RegExp(policy['params']['regexp']).test(value);
                    validation = matches ? undefined : getUItypeValidationMessage(attributeInputCallback,t, 'regexMessage');
                    break;
                case 'INVALID-VALUES':
                    const invalid_values: any[] = policy['params']['values']
                    if (!isNil(invalid_values)) {
                        for (let i = 0; i < invalid_values.length; i++) {
                            if (!!value && value.indexOf(invalid_values[i]) > -1) {
                                validation = getUItypeValidationMessage(attributeInputCallback,t)
                            }
                        }
                    }
                    break;
                case 'MIN_LENGTH':
                    if (value.length < policy['params']['minLength']) {
                        const validationMessage = getUItypeValidationMessage(attributeInputCallback,t,'minLengthMessage');
                        validation = validationMessage ? validationMessage : t(`common.minLength`,{minLength: policy['params']['minLength']});
                    }
                    break;
                case 'MAX_LENGTH':
                    if (value.length > policy['params']['maxLength']) {
                        const validationMessage = getUItypeValidationMessage(attributeInputCallback, t,'maxLengthMessage');
                        validation = validationMessage ? validationMessage : t(`common.maxLength`, {maxLength: policy['params']['maxLength']});
                    }

            }
        });
        if (!validation && attributeInputCallback.getType() === CallbackType.ValidatedCreatePasswordCallback) {
            validation = validatedCreatePasswordCallback(attributeInputCallback, value, t);
        }
        if (!!validationValues && !validation) {
            let valid: boolean = false;
            validationValues.value.forEach(validationValue => {
                if (value.indexOf(validationValue) > -1) {
                    valid = true;
                }
            })
            if (!valid) {
                validation = validationValues.message;
            }
        }

        if (!!validSecondaryEmail && !validation) {
            let valid: boolean = false;
            if (value.toLowerCase() !== validSecondaryEmail.value.toLowerCase()) {
                valid = true;
            }
            if (!valid) {
                validation = validSecondaryEmail.message;
            }
        }


    }

    return validation;
}

const getUiElementBasedOnCallBackType = (attributeInputCallback: AttributeInputCallback<string | number | boolean>, metaDataMap: any,t: (key:string,param?:Record<string,any>) => string) => {
    let children: JSX.Element = <></>;
    const callbackType: CallbackType = attributeInputCallback.getType();
    const callBackMetaData = metaDataMap.get("typeBasedCallbacks") ? metaDataMap.get("typeBasedCallbacks")[callbackType] : null;
    if (callBackMetaData) {
        switch (callbackType) {
            case "NameCallback":
                children = <CustomTextField 
                    className="lowHeight"
                    key={callBackMetaData.name}
                    id={callBackMetaData.name}
                    name={callBackMetaData.name}
                    disabled={callBackMetaData.isDisabled}
                    label={t(callBackMetaData.prompt)}
                    validation={{
                        validate: (value: string) => {
                            return getValidationMessage(attributeInputCallback, value,t);
                        }
                    }}
                    margin="normal"
                    required={callBackMetaData.isRequired}
                    fullWidth
                />
                break;
            case "PasswordCallback":
                children = <CustomPasswordElement margin="dense" className="lowHeight"
                    key={callBackMetaData.name}
                    id={callBackMetaData.name}
                    name={callBackMetaData.name}
                    disabled={callBackMetaData.isDisabled}
                    label={t(callBackMetaData.prompt)}
                    required={callBackMetaData.isRequired}
                    fullWidth
                    validation={{
                        validate: (value: string) => {
                            return getValidationMessage(attributeInputCallback, value,t);
                        }
                    }} />
                break;
            default:
                break;
        }
    }

    return children;
}

 const handleClick = (link:string) => {
    if (link) {
      window.open(link, "_blank", "noopener,noreferrer");
    }
  
  };

export const getUiElementBasedOnCallBack = (attributeInputCallback: AttributeInputCallback<string | number | boolean>, metaDataMap: any) => {
  const {t} = useTranslation();
      let extraLinkTextPrefix;
      let extraLinkTextSuffix;
    let children: JSX.Element = <></>;
    const uiTypeParams = getPolicyByPolicyID(attributeInputCallback, "UI-TYPE")
    const uiType = uiTypeParams ? uiTypeParams['types'] : null;
    const required: boolean = uiTypeParams ? uiTypeParams['required'] : null;
    const isRequiredMetaData = uiTypeParams ? metaDataMap.get(attributeInputCallback.getName())?.isRequired : null;

    switch (uiType) {
        case "text":
            children = (
                <>
                    {/*    <span className="fieldLabel">{attributeInputCallback.getPrompt()} {attributeInputCallback.isRequired() ? '*' : ''}</span> */}
                    <CustomTextField  className="lowHeight"
                        key={attributeInputCallback.getName()}
                        id={attributeInputCallback.getName()}
                        name={attributeInputCallback.getName()}
                        disabled={metaDataMap.get(attributeInputCallback.getName())?.isDisabled}
                        label={t(attributeInputCallback.getPrompt())}
                        validation={{
                            validate: (value: string) => {
                                return getValidationMessage(attributeInputCallback, value,t);
                            }
                        }}
                        margin="normal"
                        required={isRequiredMetaData ? isRequiredMetaData : required}
                        fullWidth
                    />
                </>);
            break;
        case 'PasswordElementWithoutConfirm':
            children = <CustomPasswordElement margin={'dense'} className="lowHeight"
                key={attributeInputCallback.getPrompt()}
                id={attributeInputCallback.getPrompt()}
                name={attributeInputCallback.getPrompt()}
                label={attributeInputCallback.getPrompt()}
                required
                fullWidth
                validation={{
                  validate: (value: string) => {
                        return getValidationMessage(attributeInputCallback, value,t);
                    }
                }} />
            break;
        case 'PasswordElement':
            const confirmLabel = uiTypeParams ? uiTypeParams['confirmLabel'] : null;
            const label =  uiTypeParams ? uiTypeParams['label'] : null;
            children = <CustomPasswordElement margin={'dense'} className="lowHeight"
                isWithRepeat={true}
                key={attributeInputCallback.getPrompt()}
                id={attributeInputCallback.getPrompt()}
                name={attributeInputCallback.getPrompt()}
                label={t( label ? label : attributeInputCallback.getPrompt())}
                confirmLabel={t(confirmLabel)}
                required
                fullWidth
                validation={{
                    validate: (value: string) => {
                        return getValidationMessage(attributeInputCallback, value,t);
                    }
                }} />
            break;
        case 'dropdown':
        case "select":
            children = (<>
                {/* <span key={attributeInputCallback.getName() + 'fieldLabel'} className="fieldLabel">{attributeInputCallback.getPrompt()} {attributeInputCallback.isRequired() ? '*' : ''}</span> */}
                <CustomSelectField className="lowHeight"
                    key={attributeInputCallback.getName()}
                    id={attributeInputCallback.getName()}
                    name={attributeInputCallback.getName()}
                    value={attributeInputCallback.getInputValue() ? attributeInputCallback.getInputValue() as string : undefined}
                    disabled={metaDataMap.get(attributeInputCallback.getName())?.isDisabled}
                    // disabled={(typeof disabled)==='string' ? store.getState()?.reRender.stateDisabled    : isDisabled}
                    label={t(attributeInputCallback.getPrompt())}
                    options={getOptionsFromPolicy(attributeInputCallback, metaDataMap.get(attributeInputCallback.getName())?.customCountryTopElement,uiType)}
                   // onChange={getOnChangeFunctions(selectKey ? selectKey : attributeInputCallback.getName(), attributeInputCallback, formContext)}
                   // objectOnChange={getObjectOnChange(attributeInputCallback.getName())}
                    required={isRequiredMetaData ? isRequiredMetaData : required}
                    validation={{
                        validate: (value: string) => {
                            return getValidationMessage(attributeInputCallback, value,t);
                        }
                    }}
                    halfWidth={metaDataMap.get(attributeInputCallback.getName())?.halfWidth}
                    valueKey={'value'}
                    labelKey="name" fullWidth margin="normal" />
            </>)
            break;
        case "link":
                  extraLinkTextPrefix = metaDataMap.get(attributeInputCallback.getName())?.extraLinkTextPrefix ? metaDataMap.get(attributeInputCallback.getName())?.extraLinkTextPrefix : "";
                  extraLinkTextSuffix = metaDataMap.get(attributeInputCallback.getName())?.extraLinkTextSuffix ? metaDataMap.get(attributeInputCallback.getName())?.extraLinkTextSuffix : "";
                 children= <div className="linkCSS">
                     <span dangerouslySetInnerHTML={{ __html: t(extraLinkTextPrefix) }}></span> <a href="javascript:void(0);"   style={{fontFamily:'"Objektiv Mk2 Regular", "Muli", "Arial", sans-serif'}} onClick={(e) => { e.preventDefault(); metaDataMap.get(attributeInputCallback.getName())?.onClick?.()}} ><span dangerouslySetInnerHTML={{__html: t(attributeInputCallback.getPrompt()) }}></span></a> 
                     <span dangerouslySetInnerHTML={{ __html: t(extraLinkTextSuffix) }}></span>
                 </div>
                    break;
         case "plainText":
                extraLinkTextPrefix = metaDataMap.get(attributeInputCallback.getName())?.extraLinkTextPrefix ? metaDataMap.get(attributeInputCallback.getName())?.extraLinkTextPrefix : "";
                  extraLinkTextSuffix = metaDataMap.get(attributeInputCallback.getName())?.extraLinkTextSuffix ? metaDataMap.get(attributeInputCallback.getName())?.extraLinkTextSuffix : "";
                 children=  <div className="painText" >
                         <span dangerouslySetInnerHTML={{ __html: t(extraLinkTextPrefix) }}></span>
                        <div  dangerouslySetInnerHTML={{__html : t(attributeInputCallback.getPrompt(),metaDataMap.get(attributeInputCallback.getName())?.translationData)}}/>
                        <span dangerouslySetInnerHTML={{ __html: t(extraLinkTextSuffix) }}></span>
                        </div>
                    break;
        case 'submitButton':
                // children=  <div  className = "submitButton"><Button type="submit" variant="contained" color="primary" onClick={(()=>handleClick(attributeInputCallback.getPrompt()))}>
                //     Register</Button></div>
                children=  <div className="submitButtonBase" ><Button  className = "submitButton" type="submit" onClick={(()=>handleClick(attributeInputCallback.getPrompt()))}>
                   {metaDataMap.get(attributeInputCallback.getName())?.translationKey ? metaDataMap.get(attributeInputCallback.getName())?.translationKey : t('common.registrationButtonHYPR')}</Button></div>
                break;                         
        default:
            children = getUiElementBasedOnCallBackType(attributeInputCallback, metaDataMap,t)
    }

    return children;
}